import { type CountdownOptions } from "@client/lib/jquery/countdown";
import { getDateTimeValue } from "@client/lib/settings";
import {
  combinedSettingsSelector,
  funnelInfoSelector,
  getSettingValueSelector,
  idPropsSelector,
  isEditModeSelector,
  TargetSelector
} from "@client/selectors";
import { createSelector } from "reselect";

export const makeCountdownOptionsSelector = () => {
  const typeSelector = getSettingValueSelector(TargetSelector.Entity, "countType");
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "timerDate", converter: getDateTimeValue, prop: "date" },
    { name: "timerDay", prop: "day" },
    { name: "timerHour", prop: "hour" },
    { name: "timerMinute", prop: "minute" },
    { name: "timerSecond", prop: "second" },
    "redirectUrl"
  ]);
  const localStorageKeySelector = createSelector([idPropsSelector], (id) => `wscCountdown-${id}`);
  return createSelector(
    [localStorageKeySelector, typeSelector, funnelInfoSelector, settingsSelector, isEditModeSelector],
    (localStorageKey, type, funnelInfo, { redirectUrl, ...settings }, isEditMode): CountdownOptions => {
      if (type === "inherit-funnel") {
        return {
          localStorageKey,
          type: "fixed",
          date: funnelInfo?.expiryDate,
          redirectUrl: isEditMode ? null : funnelInfo?.redirectUrl
        };
      }

      return {
        ...settings,
        localStorageKey,
        redirectUrl: redirectUrl && !isEditMode ? redirectUrl : undefined,
        type
      };
    }
  );
};
